import type { PickerData, WeekRow } from '@/lib/types'
import type { NewRowSelection } from './week-rows'
import { RowLabel } from './RowLabel'
import { RowTargetMenu } from './RowTargetMenu'
import type { RowMenuState } from './week-rows'

interface RowLabelEditableProps {
  row: WeekRow
  firstOfClient: boolean
  isContinuation: boolean
  menu: RowMenuState
  pickers: PickerData | undefined
  weekId: string
  personId?: string
  /** Vervangt de regel lokaal zolang er nog niets is opgeslagen. */
  onLocalCommit: (selection: NewRowSelection) => void
}

/**
 * Het regellabel met zijn drie klikdoelen. Klant, project en categorie openen elk
 * dezelfde kiezer op hun eigen niveau; wat niet te wijzigen valt blijft gewone tekst.
 * De klantnaam staat alleen op de eerste regel van een klantblok, dus daar zit ook het
 * enige klantdoel.
 */
export function RowLabelEditable({
  row,
  firstOfClient,
  isContinuation,
  menu,
  pickers,
  weekId,
  personId,
  onLocalCommit,
}: RowLabelEditableProps) {
  function slot(level: 'client' | 'project' | 'category', allowed: boolean) {
    if (!allowed || !pickers) return undefined
    return (
      <RowTargetMenu
        row={row}
        pickers={pickers}
        level={level}
        entryIds={menu.entryIds}
        weekId={weekId}
        personId={personId}
        onLocalCommit={menu.isLocalRow ? onLocalCommit : undefined}
      />
    )
  }

  return (
    <RowLabel
      row={row}
      firstOfClient={firstOfClient}
      isContinuation={isContinuation}
      clientSlot={firstOfClient ? slot('client', menu.canChangeClient) : undefined}
      projectSlot={slot('project', menu.canChangeProject)}
      categorySlot={slot('category', menu.canChangeCategory)}
    />
  )
}
